import { mixpanel } from '@fiverr-private/obs';

export interface MixpanelEventData {
    eventName: string;
    clickedElement?: string;
    position?: number;
    elementSource?: string;
    elementSourceOrder?: number;
    clickedElementText?: string;
}

export const sendMixpanelEvent = (data: MixpanelEventData): void => {
    const eventData: Record<string, any> = {
        Origin: 'Homepage',
        'Page Name': 'brand-lohp-v17',
    };

    if (data.clickedElement) {
        eventData['Clicked Element'] = data.clickedElement;
    }
    if (data.position) {
        eventData['Clicked Element Order'] = data.position;
    }
    if (data.elementSource) {
        eventData['Element Source'] = data.elementSource;
    }
    if (data.elementSourceOrder) {
        eventData['Element Source Order'] = data.elementSourceOrder;
    }
    if (data.clickedElementText) {
        eventData['Clicked Element Text'] = data.clickedElementText;
    }

    mixpanel.track(data.eventName, eventData);
};
